export default __webpack_public_path__ + "static/media/currency_arrow.1b0d138d.svg";